import { NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-colored-chip',
  imports: [NgStyle],
  templateUrl: './colored-chip.component.html',
  styleUrl: './colored-chip.component.scss'
})
export class ColoredChipComponent {

  @Input() public backgroundColor: string = '';
  @Input() public color: string = '';
  @Input() public borderColor: string = '';
  @Input() public text: string = '';
  @Input() public opacity: number =  1;
}
